import BankAccountDetailsDirective from './BankAccountDetailsDirective';
import CreditCardDetailsDirective from './CreditCardDetailsDirective';
import 'underscore';

export default angular.module('edge.platform.paymentdetails', [])

    .directive('gwPlBankAccountDetails', BankAccountDetailsDirective)
    .directive('gwPlCreditCardDetails', CreditCardDetailsDirective);